import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { RectangularTextButton } from "components/Base/Buttons";

interface MoveConfirmDialogProps {
  open: boolean;
  warningMessage?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const MoveConfirmDialog: React.FC<MoveConfirmDialogProps> = ({
  open,
  warningMessage = 'Are you sure you want to proceed with triggering this interaction? \n If you have selected that this interaction be "Fulfilled By Pathways", your organisation will be charged accordingly.',
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Confirm Move</DialogTitle>

      <DialogContent>
        <Typography>{warningMessage}</Typography>
      </DialogContent>

      <DialogActions>
        <RectangularTextButton colour="clear" onClick={onCancel}>
          Cancel
        </RectangularTextButton>

        <RectangularTextButton
          colour="highlighted"
          onClick={onConfirm}
          primaryColor="#d32f2f"
          textColor="#fff"
        >
          Move
        </RectangularTextButton>
      </DialogActions>
    </Dialog>
  );
};

export default MoveConfirmDialog;